/**
 * 收费处路由
 */
const tollRoutes = [
  {
    path: 'receipt',
    name: 'receipt',
    meta: {
      title: '收费',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/toll/receipt.vue'], resolve)
  },
  {
    path: 'special-receipt',
    name: 'special-receipt',
    meta: {
      title: '处方外购',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/toll/specialReceipt.vue'], resolve)
  },
  {
    path: 'set-printer',
    name: 'set-printer',
    meta: {
      title: '设置打印机',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/toll/set-printer.vue'], resolve)
  },
  {
    path: 'receipt-detail',
    name: 'receipt-detail',
    meta: {
      title: '收费详情',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: {
          title: '收费',
          path: '/default/receipt'
        }
      }
    },
    component: () => {
      // if (process.env.HOSPITAL === 'runsheng' || process.env.HOSPITAL === 'houzhai') {
      //   return import('../views/page/toll/receipt-detail-runsheng.vue')
      // }
      return import('../views/page/toll/receipt-detail.vue')
    }
  },
  {
    path: 'special-receipt-detail',
    name: 'special-receipt-detail',
    meta: {
      title: '收费详情',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: {
          title: '特殊门诊收费',
          path: '/default/special-receipt'
        }
      }
    },
    component: resolve => require(['../views/page/toll/receipt-detail-runsheng.vue'], resolve)
  },
  {
    path: 'other-receipt',
    name: 'other-receipt',
    meta: {
      title: '其他收费',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace'
      }
    },
    component: resolve => require(['../views/page/toll/other-receipt.vue'], resolve)
  },
  {
    path: 'refunds',
    name: 'refunds',
    meta: {
      title: '退费',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: () => {
      // if (process.env.HOSPITAL === 'runsheng' || process.env.HOSPITAL === 'houzhai') {
      //   return import('../views/page/toll/refunds-runsheng.vue')
      // }
      return import('../views/page/toll/refunds.vue')
    }
  },
  {
    path: 'refund-application',
    name: 'refund-application',
    meta: {
      title: '退费申请',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/toll/refund-application.vue'], resolve)
  },
  {
    path: 'day-settlement',
    name: 'day-settlement',
    meta: {
      title: '日结',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/toll/day-settlement.vue'], resolve)
  },
  {
    path: 'day-settlement-query',
    name: 'day-settlement-query',
    meta: {
      title: '日结查询',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/toll/day-settlement-query.vue'], resolve)
  },
  {
    path: 'receipt-query',
    name: 'receipt-query',
    meta: {
      title: '收费查询',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: () => {
      if (process.env.HOSPITAL === 'runsheng' || process.env.HOSPITAL === 'houzhai') {
        return import('../views/page/toll/receipt-query-runsheng.vue')
      }
      return import('../views/page/toll/receipt-query.vue')
    }
  },
  {
    path: 'receipt-query-vaccine',
    name: 'receipt-query-vaccine',
    meta: {
      title: '疫苗收费查询',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/toll/receipt-query-vaccine.vue'], resolve)
  },
  {
    path: 'inpatient-integrated-services',
    name: 'inpatient-integrated-services',
    meta: {
      title: '住院综合业务',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/live-toll/inpatient-integrated-services.vue'], resolve)
  },
  {
    path: 'inpatient-integrated-services-detail/:inpatient_record_id/:patient_id',
    name: 'inpatient-integrated-services-detail',
    meta: {
      title: '住院病人收费结算详情',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: {
          title: '住院综合业务',
          path: '/default/inpatient-integrated-services'
        }
      }
    },
    component: resolve => require(['../views/page/live-toll/inpatient-integrated-services-detail.vue'], resolve)
  },
  {
    path: 'inpatient-medical-insurance-settlement',
    name: 'inpatient-medical-insurance-settlement',
    meta: {
      title: '住院病人医保结算',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/live-toll/inpatient-medical-insurance-settlement.vue'], resolve)
  },
  {
    path: 'inpatient-medical-insurance-settlement-detail',
    name: 'inpatient-medical-insurance-settlement-detail',
    meta: {
      title: '医保结算单',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: {
          title: '住院病人医保结算',
          path: '/default/inpatient-medical-insurance-settlement'
        }
      }
    },
    component: resolve => require(['../views/page/live-toll/inpatient-medical-insurance-settlement-detail.vue'], resolve)
  },
  {
    path: 'inpatient-yibaofeiyong',
    name: 'inpatient-yibaofeiyong',
    meta: {
      title: '医保费用审核',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/live-toll/inpatient-yibaofeiyong.vue'], resolve)
  },
  // 医保
  {
    path: 'insurance-list',
    name: 'insurance-list',
    meta: {
      title: '住院病人医保结算',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    // component: resolve => require(['../views/page/medical-insurance/insurance-list.vue'], resolve)
    component: () => {
      if (process.env.YB_LOCAL === 'jieyang') {
        return import('../views/page/medical-insurance-jieyang/insurance-list.vue')
      } else {
        return import('../views/page/medical-insurance/insurance-list.vue')
      }
    }
  },
  {
    path: 'workplace-jieyang',
    name: 'workplace-jieyang',
    meta: {
      title: '医保查询',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace'
      }
    },
    // component: resolve => require([insuranceRegistration], resolve)
    component: () => {
      if (process.env.YB_LOCAL === 'jieyang') {
        return import('../views/page/medical-insurance-jieyang/workplace-jieyang.vue')
      } else {
        return import('../views/page/medical-insurance/insurance-registration.vue')
      }
    }
  },
  // 医保结算
  {
    path: 'audit-list',
    name: 'audit-list',
    meta: {
      title: '住院医保清算',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/medical-insurance-jieyang/audit-list.vue'], resolve)
  },
  {
    path: 'insurance/insurance-fee',
    name: 'insurance-fee',
    meta: {
      title: '医保综合业务详情',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: {
          title: '住院病人医保结算',
          path: '/default/basy-list'
        }
      }
    },
    // component: resolve => require(['../views/page/medical-insurance/insurance-fee.vue'], resolve)
    component: () => {
      if (process.env.YB_LOCAL === 'jieyang') {
        return import('../views/page/medical-insurance-jieyang/insurance-fee.vue')
      } else {
        return import('../views/page/medical-insurance/insurance-fee.vue')
      }
    }
  },
  {
    path: 'basy-list',
    name: 'basy-list',
    meta: {
      title: '病案首页查询',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/medical-insurance/basy-list.vue'], resolve)
  },
  {
    path: 'inpatient-business',
    name: 'inpatient-business',
    meta: {
      title: '住院医保业务',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/guangdong-medical-insurance/inpatient-business.vue'], resolve)
  },
  {
    path: 'medical-insurance-liquidation',
    name: 'medical-insurance-liquidation',
    meta: {
      title: '门诊费用结算(清算)',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/guangdong-medical-insurance/medical-insurance-liquidation.vue'], resolve)
  },
  {
    path: 'medical-insurance-liquidation-inpatient',
    name: 'medical-insurance-liquidation-inpatient',
    meta: {
      title: '住院费用结算(清算)',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/guangdong-medical-insurance/medical-insurance-liquidation-inpatient.vue'], resolve)
  },
  {
    path: 'file-load',
    name: 'file-load',
    meta: {
      title: '目录下载',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/guangdong-medical-insurance/file-load.vue'], resolve)
  },
  {
    path: 'category-query',
    name: 'category-query',
    meta: {
      title: '目录信息查询',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/guangdong-medical-insurance/category-query.vue'], resolve)
  },
  {
    path: 'transfer-list',
    name: 'transferList',
    meta: {
      title: '转院备案',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/guangdong-medical-insurance/transferList.vue'], resolve)
  },
  {
    path: 'request-records',
    name: 'requestRecords',
    meta: {
      title: '交易冲正',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/guangdong-medical-insurance/request-records.vue'], resolve)
  },
  {
    path: 'outpatient-settlements-upload',
    name: 'outpatientFeeSettlementsUpload',
    meta: {
      title: '门诊清算单上报',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/guangdong-medical-insurance/fee-settlements-upload.vue'], resolve)
  },
  {
    path: 'inpatient-settlements-upload',
    name: 'inpatientFeeSettlementsUpload',
    meta: {
      title: '住院清算单上报',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/guangdong-medical-insurance/fee-settlements-upload.vue'], resolve)
  },
  {
    path: 'inpatient-settlements-upload-2022',
    name: 'inpatientFeeSettlementsUpload-2022',
    meta: {
      title: '住院清算单上报-2022',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/guangdong-medical-insurance/fee-settlements-upload-2022.vue'], resolve)
  },
  {
    path: 'score-clearing',
    name: 'scoreClearing',
    meta: {
      title: '医保清分',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/guangdong-medical-insurance/score-clearing.vue'], resolve)
  },
  {
    path: 'outpatient-self-pay-upload',
    name: 'outpatientSelfPayUpload',
    meta: {
      title: '门诊自费患者收费上传',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/guangdong-medical-insurance/outpatient-self-pay-upload.vue'], resolve)
  },
  {
    path: 'inpatient-self-pay-upload',
    name: 'inpatientSelfPayUpload',
    meta: {
      title: '住院自费患者收费上传',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/guangdong-medical-insurance/inpatient-self-pay-upload.vue'], resolve)
  },
  {
    path: 'ybinfo-query',
    name: 'ybInfoQuery',
    meta: {
      title: '医保服务信息查询',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/guangdong-medical-insurance/ybinfo-query.vue'], resolve)
  },
  {
    path: 'ybpinfo-query',
    name: 'ybInfoQuery',
    meta: {
      title: '医保个人信息查询',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/guangdong-medical-insurance/ybpinfo-query.vue'], resolve)
  },
  {
    path: 'birth-put-on',
    name: 'birthPutOn',
    meta: {
      title: '生育备案',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/guangdong-medical-insurance/birth-put-on.vue'], resolve)
  },
  {
    path: 'fee-apply-result',
    name: 'feeApplyResult',
    meta: {
      title: '申报汇总信息查询',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/guangdong-medical-insurance/fee-apply-result.vue'], resolve)
  },
  {
    path: 'settlement-list-upload-result',
    name: 'settlementListUploadResult',
    meta: {
      title: '结算清单信息查询',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/guangdong-medical-insurance/settlement-list-upload-result.vue'], resolve)
  },
  {
    path: 'invoice-inquiry',
    name: 'invoice-inquiry',
    meta: {
      title: '电票查询',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/toll/invoice-inquiry.vue'], resolve)
  },
  {
    path: 'invoice-update-outpatient',
    name: 'invoice-update-outpatient',
    meta: {
      title: '门诊医疗票据上传',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/guangdong-medical-insurance/invoice-update/outpatient.vue'], resolve)
  },
  {
    path: 'invoice-update-inpatient',
    name: 'invoice-update-inpatient',
    meta: {
      title: '住院医疗票据上传',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/guangdong-medical-insurance/invoice-update/inpatient.vue'], resolve)
  },
  {
    path: 'inpatient_fee_review',
    name: 'inpatient_fee_review',
    meta: {
      title: '住院病人费用查看',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/guangdong-medical-insurance/inpatient_fee_review.vue'], resolve)
  }
]

export default tollRoutes
